<template>
    <div class="d-flex align-items-center">

        <!-- Tamaño mínimo del texto, para la tabla de componentes -->
        <div v-if="showSettingsMinFontSizeToTableComponents">
            <i class="fa fa-font mr-2" aria-hidden="true"></i>
            <el-select v-b-tooltip.hover title="Tamaño mínimo del texto. Si no se define, se usa el tamaño dinámico ajustado al ancho y alto de la sección." v-model="activeSection.minFontSize" name="min_font_size" :style="{ width: '80px' }">
                <el-option v-for="x in measuresFonts" :key="x" :label="`${x} pt`" :value="x"></el-option>
            </el-select>
        </div>

        <!-- Tamaño del texto fijo -->
        <div v-if="showSettingsFontSize || showFontSizeSettingToOnlyComponentSection">
            <i class="fa fa-font mr-2" aria-hidden="true"></i>
            <el-select v-b-tooltip.hover :title="getTitleToFontSize" v-model="activeSection.fontSize" name="font_size" :style="{ width: '80px' }">
                <el-option v-for="x in measuresFonts" :key="x" :label="`${x} pt`" :value="x"></el-option>
            </el-select>
        </div>
        
        <!-- Tamaño máximo del texto, para los campos de texto son dinámicos -->
        <div v-else-if="showSettingsMaxFontSize">
            <i class="fa fa-font mr-2" aria-hidden="true"></i>
            <el-select v-b-tooltip.hover title="Tamaño máximo del texto. Si no se define, se usa el tamaño dinámico ajustado al ancho y alto de la sección." v-model="activeSection.maxFontSize" name="max_font_size" :style="{ width: '80px' }">
                <el-option v-for="x in measuresFonts" :key="x" :label="`${x} pt`" :value="x"></el-option>
            </el-select>
        </div>
        
        <!-- Tamaño máximo para campos del tipo: PICTOGRAMS, WARNING_WORD, SAP_NUMBER, TRANSPORT, HAZARD_STATEMENTS, PRECAUTIONARY_INFO, EPPS -->
        <div v-else-if="showMaxFontSizeToSpecialSections">
            <i class="fa fa-font mr-2" aria-hidden="true"></i>
            <el-select v-b-tooltip.hover title="Tamaño máximo del texto. Si no se define, se usa el tamaño dinámico ajustado al ancho y alto de la sección." v-model="activeSection.maxFontSize" name="max_font_size" :style="{ width: '80px' }">
                <el-option v-for="x in measuresFonts" :key="x" :label="`${x} pt`" :value="x"></el-option>
            </el-select>
        </div>

        <div v-if="onSectionIfDifferentToTableComponents && (showSettingsFontSize || showSettingsMaxFontSize || showMaxFontSizeToSpecialSections)" class="separator-item-bar"></div>

        <!-- Estilo tipo de letra -->
        <div v-if="onSectionIfDifferentToTableComponents" class="d-flex align-items-center">
            <b-form-checkbox v-b-tooltip.hover title="Estilo de letra" v-model="activeSection.fontWeight" value="bold" unchecked-value="normal"
                :button-variant="activeSection.fontWeight === 'bold' ? 'light' : 'none'"
                name="checkbox-btn-font-weight-bold" button><span
                    :style="{ fontWeight: 'bold' }">B</span></b-form-checkbox>
            <b-form-checkbox v-b-tooltip.hover title="Subrayado" v-model="activeSection.textDecoration" value="underline" unchecked-value="normal"
                :button-variant="activeSection.textDecoration === 'underline' ? 'light' : 'none'"
                name="checkbox-btn-text-decoration-underline" button><span
                    :style="{ textDecoration: 'underline' }">S</span></b-form-checkbox>
        </div>

        <div v-if="onSectionIfDifferentToTableComponents && showSettingsToText" class="separator-item-bar"></div>

        <!-- Color del texto -->
        <div v-if="showSettingsToText && onSectionIfDifferentToTableComponents" class="d-flex align-items-center" :style="{ width: '45px' }">
            <strong class="mr-1">A</strong>
            <b-form-input v-b-tooltip.hover title="Color del texto" v-model="activeSection.fontColor" type="color" name="font_color" size="sm"></b-form-input>
        </div>

        <div class="separator-item-bar"></div>

        <!-- Color del fondo -->
        <div class="d-flex align-items-center" :style="{ width: '45px' }">
            <strong class="mr-1"><i class="fa fa-paint-brush" aria-hidden="true"></i></strong>
            <b-form-input v-b-tooltip.hover title="Color del fondo" v-model="activeSection.backgroundColor" type="color" name="background_Color"
                size="sm"></b-form-input>
        </div>

        <div class="separator-item-bar"></div>

    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'FontSettings',
    
    computed: {
        ...mapState('labelDesigner', [
            'activeSection',
            'measuresFonts',
            'basicValuesDynamicFontSize'
        ]),

        showSettingsToText() {
            if (!this.activeSection) return false
            return this.activeSection && (this.activeSection.type == 'text' || this.activeSection.type == 'TEXT' || this.activeSection.type === 'CLEAR_BOX') ? true : false
        },

        isDifferentToWordDynamicFontSize() {
            const values = this.basicValuesDynamicFontSize
            return (values.find(x => x === this.activeSection.type) || values.find(x => x === this.activeSection.code)) ? false : true
        },

        showSettingsFontSize() {
            return this.showSettingsToText && this.isDifferentToWordDynamicFontSize
        },

        showSettingsMaxFontSize() {
            return this.showSettingsToText && !this.isDifferentToWordDynamicFontSize
        },

        showMaxFontSizeToSpecialSections() {
            return ['PICTOGRAMS', 'WARNING_WORD', 'SAP_NUMBER', 'TRANSPORT', 'HAZARD_STATEMENTS', 'PRECAUTIONARY_INFO', 'EPPS', 'TABLE_COMPONENTS']
                .find(x => this.activeSection.code === x) ? true : false
        },

        onSectionIfDifferentToTableComponents() {
            return this.activeSection.code !== 'TABLE_COMPONENTS'
        },

        showSettingsMinFontSizeToTableComponents() {
            return this.activeSection.code === 'TABLE_COMPONENTS'
        },

        showFontSizeSettingToOnlyComponentSection() {
            return ['COMPONENT_CAS', 'COMPONENT_PERCENT', 'COMPONENT_CAS_PERCENT'].find(x => x === this.activeSection.code) ? true : false
        },

        getTitleToFontSize() {
            return this.showFontSizeSettingToOnlyComponentSection ? 'Tamaño del texto fijo' : 'Tamaño del texto'
        }

    }
}
</script>

<style scoped>
.separator-item-bar {
    width: 1px;
    height: 35px;
    background-color: #e0e0e0;
    margin: 0 10px;
}
</style> 